import React from 'react'

import { PageHeading, PageTitle } from 'uiComponents/typography'
import SearchField from 'uiComponents/search/searchField'
import CartTable from './cartTable'
import ErrorBoundary from 'uiComponents/errorBoundary'
import { useTranslation } from 'translations'

const Cart: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const { t } = useTranslation()
    return (
        <div id="cart__elem">
            <PageTitle>{t('orders.cartOld.title')}</PageTitle>
            <PageHeading>{t('orders.cartOld.subtitle')}</PageHeading>
            <div style={{ paddingBottom: '2rem' }}>
                <SearchField placeholder={t('orders.cartOld.searchPlaceholder')} />
            </div>
            <div>
                <CartTable />
            </div>
            <ErrorBoundary>{children}</ErrorBoundary>
        </div>
    )
}

export default Cart
